// extracted by mini-css-extract-plugin
export var audioPlayer = "_sw-0";